import { render, staticRenderFns } from "./TechTransferMemberSave.vue?vue&type=template&id=7bd5a266&"
import script from "./TechTransferMemberSave.vue?vue&type=script&lang=js&"
export * from "./TechTransferMemberSave.vue?vue&type=script&lang=js&"
import style0 from "./TechTransferMemberSave.vue?vue&type=style&index=0&id=7bd5a266&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports